import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const elem = document.getElementById("mainContent");
    if (elem) {
      elem.scrollTop = 0;
      elem.scrollLeft = 0;
    }
  }, [pathname]);

  return null;
}
